// Module
var code = "<div class=\"gridFilter\">\n    <div layout-xs=\"column\" layout-gt-xs=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"end end\">\n        <div class=\"divider\" flex></div>\n        <dir-pagination-controls pagination-id=\"safety-plan-documents\"></dir-pagination-controls>\n    </div>\n</div>";
// Exports
module.exports = code;